import { Vue, Component } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { DynamicLinkConfig } from "@/store/types";
import { stringMixin } from "@/mixins";

const { formatString } = stringMixin.methods;

@Component({})
export default class LinkedTasksMixin extends Vue {
	@Getter private getFeature: (featureNames: string[]) => boolean;
	@Getter("getDynamicLinkConfig") private dynamicLinkConfig: DynamicLinkConfig;

	/**
	 * Returns true if the feature flags necessary for the third party tasks integration are enabled, and
	 * link config is setup.
	 */
	public get tasksEnabled() {
		return (
			this.getFeature(["Integration", "Tasks"]) &&
			this.getFeature(["Integration", "DynamicLink"]) &&
			this.dynamicLinkConfig != null
		);
	}

	/**
	 * Returns the URL for a given task ID, using the regex and format string provided
	 * via the Dynamic Link config.
	 */
	public getTaskUrl(taskId: string) {
		if (!this.dynamicLinkConfig || !this.dynamicLinkConfig.linkFormatter) {
			return null;
		}

		let taskIdMatch = taskId.match(this.dynamicLinkConfig.testPattern);
		if (!taskIdMatch) {
			return null;
		}

		return formatString(this.dynamicLinkConfig.linkFormatter, ...taskIdMatch);
	}
}
